module.exports = __webpack_public_path__ + "static/media/bebidas.242e11ec.png";